/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastschriftzugestimmt1Inputs */



/**

* @param {_Field_Lastschriftzugestimmt1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastschriftzugestimmt1 = /** @type {((inputs?: _Field_Lastschriftzugestimmt1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastschriftzugestimmt1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Lastschrift zugestimmt")
});
export { _field_lastschriftzugestimmt1 as "_field_lastschriftZugestimmt" }